import * as React from 'react';
import i18next from 'i18next';
import { ActionTotals } from 'app/hooks/useActionTotals';
import { formatMillionsUSD } from '~utils/investment';
import styles from './styles.module.scss';
import './i18n';

interface Props {
  /** `null` while loading. */
  totals: ActionTotals | null;
  /** `card`: white card over a page header; `bar`: the Home's "Resumen de proyectos y acciones" bar. */
  variant: 'card' | 'bar';
}

/** "Cantidad · Inversión estimada (USD millones)", separated by a vertical rule. */
const StatsSummary = ({ totals, variant }: Props) => (
  <section className={`${styles.summary} ${styles[variant]}`} aria-busy={totals === null}>
    {variant === 'bar' && <h2 className={styles.title}>{i18next.t('stats-summary:title')}</h2>}
    <dl className={styles.figures}>
      <div className={styles.figure}>
        <dt className={styles.label}>{i18next.t('stats-summary:totalActions')}</dt>
        <dd className={styles.count}>{totals ? totals.totalCount : '...'}</dd>
      </div>
      <div className={styles.rule} aria-hidden="true" />
      <div className={styles.figure}>
        <dt className={styles.label}>{i18next.t('stats-summary:estimatedInvestment')}</dt>
        <dd className={styles.investment}>{totals ? formatMillionsUSD(totals.totalInvestment) || '-' : '...'}</dd>
      </div>
    </dl>
  </section>
);

export default StatsSummary;
